// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__SJSUk","headline":"styles_headline__H4uDS","subheading":"styles_subheading__Et8CJ"};